import {
  createBorderedCard,
  createChipStyle
} from 'utils/helpers/styleHelpers';

import {
  baseSection,
  baseInputRoot,
  baseButton,
  baseName
} from '../components/Common';

// Modal styles
export const modalSx = {
  '& .MuiDialog-paper': {
    borderRadius: '0.5rem',
    backgroundColor: '#ffffff',
    width: '900px',
    height: 'auto',
    maxWidth: '900px !important'
  }
} as const;

export const simulatorContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#ffffff'
} as const;

export const simulatorInputSectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1rem',
  border: '1px solid #e5e7eb',
  marginBottom: '1rem',
  borderRadius: '0.5rem',
  backgroundColor: '#ffffff'
} as const;

export const simulatorInputsRowStyle = {
  display: 'flex',
  gap: '1rem',
  width: '100%'
} as const;

export const simulatorSecondInputsRowStyle = {
  display: 'flex',
  gap: '1rem',
  width: '49%'
} as const;

export const simulatorInputWrapperStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  '& .MuiOutlinedInput-root': baseInputRoot
} as const;

export const simulatorAmountWrapperStyle = {
  flex: 0.75,
  '& .MuiOutlinedInput-root': baseInputRoot
} as const;

export const simulatorCurrencyWrapperStyle = {
  flex: 0.25,
  '& .MuiOutlinedInput-root': baseInputRoot
} as const;

export const simulatorSimulateButtonStyle = {
  ...baseButton,
  alignSelf: 'flex-start'
} as const;

export const simulatorCloseButtonStyle = baseButton;

export const simulatorContentStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column'
} as const;

export const simulatorEmptyStateStyle = {
  display: 'flex',
  justifyContent: 'center',
  height: '100%',
  textAlign: 'center'
} as const;

export const simulatorEmptyTextStyle = {
  padding: '4rem 0',
  color: '#6b7280',
  fontSize: '0.875rem'
} as const;

export const simulatorFooterStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0.75rem 1.5rem',
  borderTop: '1px solid #0000001f',
  backgroundColor: '#ffffff',
  marginTop: 'auto'
} as const;

export const simulatorStatusStyle = {
  fontSize: '0.75rem',
  color: '#6b7280'
} as const;

export const simulatorLabelStyle = {
  fontSize: '12px',
  color: '#000'
} as const;

export const resultsSummaryStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.875rem 1rem',
  borderRadius: '0.5rem',
  fontSize: '0.875rem',
  fontWeight: 500
} as const;

export const resultsSummaryIconStyle = {
  fontSize: '1.125rem',
  minWidth: '1.5rem',
  minHeight: '1.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
} as const;

export const resultsSummaryAutoApproveStyle = {
  backgroundColor: '#EDF7ED',
  color: '#1E4620'
} as const;

export const resultsSummaryManualStyle = {
  backgroundColor: '#e5f6fd',
  color: '#014361'
} as const;

export const resultsSummaryFallbackStyle = {
  backgroundColor: '#fff4e5',
  color: '#663c00'
} as const;

export const resultsSectionStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem'
} as const;

export const matchedRulesSectionStyle = {
  ...baseSection,
  border: '1px solid #00000014'
} as const;

export const matchedRuleCardStyle = createBorderedCard('#f0fdf4', '#bbf7d0');

export const matchedRuleHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
} as const;

export const matchedRuleNameStyle = {
  ...baseName,
  color: '#111827'
} as const;

export const matchedRulePriorityStyle = {
  fontSize: '0.625rem',
  fontWeight: 700,
  color: '#9ca3af',
  backgroundColor: '#f3f4f6',
  padding: '0.125rem 0.375rem',
  borderRadius: '0.5rem'
} as const;

export const matchedRuleChipsStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.375rem',
  flexWrap: 'wrap'
} as const;

export const matchedRuleConditionsStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem'
} as const;

export const suppressedRuleCardStyle = createBorderedCard('#f9fafb', '#e5e7eb');

export const suppressedRuleNameStyle = {
  ...baseName,
  fontSize: '0.875rem',
  color: '#9ca3af'
} as const;

export const suppressedNoticeBannerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.75rem 1rem',
  backgroundColor: '#fff4e5',
  borderRadius: '0.5rem'
} as const;

export const suppressedNoticeIconStyle = {
  fontSize: '1.5rem',
  color: '#b45309',
  minWidth: '1.5rem'
} as const;

export const suppressedNoticeTextStyle = {
  fontSize: '0.875rem',
  color: '#663c00',
  lineHeight: 1.4
} as const;

// Chip styles (using helper)
export const chipDisabledStyle = createChipStyle(
  '#f3f4f6',
  '#9ca3af',
  '#e5e7eb'
);

export const chipAutoApproveStyle = createChipStyle(
  '#f0fdf4',
  '#15803d',
  '#15803d26'
);

export const chipSequentialStyle = createChipStyle(
  '#eff6ff',
  '#1e40af',
  '#1e40af26'
);

export const chipParallelStyle = createChipStyle(
  '#fef9e7',
  '#b45309',
  '#b4530926'
);

export const finalGatesSectionStyle = {
  ...baseSection,
  borderRadius: '0.5rem',
  backgroundColor: '#ffffff',
  border: '1px solid #e5e7eb'
} as const;

export const finalGateCardStyle = createBorderedCard('#eff6ff', '#bfdbfe');

export const finalGateHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem'
} as const;

export const finalGateNumberStyle = {
  height: '1.25rem',
  display: 'flex',
  alignItems: 'center',
  px: '0.375rem',
  backgroundColor: '#078dee',
  color: 'white',
  fontSize: '0.75rem',
  fontWeight: 600,
  borderRadius: '0.5rem'
} as const;

export const finalGateNameStyle = {
  ...baseName,
  color: '#1f2937'
} as const;

export const finalGateApproversStyle = {
  fontSize: '0.75rem',
  color: '#374151'
} as const;

export const evaluationTraceSectionStyle = {
  ...baseSection,
  border: '1px solid #e5e7eb'
} as const;

export const evaluationTraceRowStyle = {
  display: 'flex',
  gap: '0.75rem',
  padding: '0.5rem 0.75rem',
  borderRadius: '0.5rem',
  alignItems: 'center'
} as const;

export const evaluationTraceNumberStyle = {
  fontSize: '0.75rem',
  fontWeight: 700,
  color: '#9ca3af',
  minWidth: '2rem'
} as const;

export const evaluationTraceContentStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  flex: 1
} as const;

export const evaluationTraceNameStyle = {
  fontSize: '0.75rem',
  fontWeight: 500,
  color: '#111827',
  width: '200px'
} as const;

export const evaluationTraceStatusStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '5.625rem',
  gap: '0.25rem',
  fontSize: '0.625rem',
  fontWeight: 700,
  padding: '0.125rem 0.5rem',
  borderRadius: '0.5rem',
  minWidth: '80px',
  justifyContent: 'center',
  textTransform: 'uppercase'
} as const;

export const evaluationTraceReasonStyle = {
  fontSize: '0.75rem',
  color: '#6b7280',
  flex: 1
} as const;

export const evaluationTraceMatchedStyle = {
  bgcolor: '#f0fdf4',
  '& .MuiTypography-root[data-status="true"]': {
    backgroundColor: '#dcfce7',
    color: '#15803d'
  }
} as const;

export const evaluationTraceNoMatchStyle = {
  '& .MuiTypography-root[data-status="false"]': {
    backgroundColor: '#fee2e2',
    color: '#dc2626'
  }
} as const;

export const matchedIconStyle = {
  fontSize: '0.875rem',
  color: '#15803d'
} as const;

export const noMatchIconStyle = {
  fontSize: '0.875rem',
  color: '#dc2626'
} as const;
